import { type FC } from 'react';

import { useNextSpecContractTime } from '@/common/hooks/next-spec-contract-time';

import { UpdateContractTimerUi } from './UpdateContractTimerUi';

const UpdateSpecContractsTimer: FC = () => {
  const timeToNextContract = useNextSpecContractTime('Golden');

  return (
    timeToNextContract && <UpdateContractTimerUi seconds={timeToNextContract} />
  );
};

export { UpdateSpecContractsTimer };
